<template>
  <v-dialog v-model="model" persistent max-width="1000px">
    <v-card>
      <v-card-title class="grey lighten-4 text-subtitle-1 font-weight-bold d-flex justify-space-between">
        <a-space>
          <span>{{ model_title }}</span>
          <a-button v-if="showinit" class="btn-error" @click="init">创建新导出任务</a-button>
        </a-space>
        <v-icon @click="onClose">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container style="max-height:600px;overflow-y: auto;">
          <a-table size="small" :columns="headers" bordered :data-source="list" :pagination="false"
            :locale="{ emptyText: '暂无数据' }">
            <template slot="index" slot-scope="text, record, index">
              {{ index + 1 }}
            </template>
            <template slot="originalname" slot-scope="text, record">
              <a v-if="record.remoteurl" href="javascript:;" @click="downloadfile(record)">{{ record.originalname }}</a>
              <span v-else>{{ record.originalname }}</span>
            </template>
            <template slot="create_time" slot-scope="text, record">
              {{ record.create_time | dateTime("YYYY-MM-DD HH:mm") }}
            </template>
            <template slot="state" slot-scope="text, record">
              <span v-if="record.state === 0" class="primary--text">
                正在处理
              </span>
              <span v-else-if="record.state === -1" class="error--text underline click">
                处理失败：{{ record.reason }}
              </span>
              <span v-else-if="record.state === 1" class="success--text">
                处理成功
              </span>
            </template>
          </a-table>
          <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" tile text @click="getdata()">刷新</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "downloadtask",
  props: ["modelTitle", "downloadType"],
  data() {
    return {
      model_title: "",
      model: false,
      download_type: "",
      page: 1,
      limit: 10,
      list: [],
      length: 0,
      count: 0,
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "文件", dataIndex: "originalname", scopedSlots: { customRender: "originalname" }, width: 120, align: "center" },
        { title: "创建时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 160, align: "center" },
        { title: "状态", dataIndex: "state", scopedSlots: { customRender: "state" }, width: 100, align: "center" },
      ],
    };
  },
  computed: {
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    showinit() {
      return this.list.length === 0 || this.list[0].state !== 0;
    },
  },
  watch: {
    modelTitle(value) {
      this.model_title = value;
    },
    downloadType(value) {
      this.download_type = value;
    },
    page() {
      this.getdata();
    },
  },
  activated() {
    this.model_title = this.modelTitle;
    this.download_type = this.downloadType;
  },
  methods: {
    init() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/downloadtask/init", { type: this.download_type }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    reset() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
    getdata() {
      this.model = true;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/downloadtask/list", { page: this.page, limit: this.limit, type: this.download_type }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    downloadfile(item) {
      if (item.remoteurl) {
        this.$download(item.remoteurl, item.originalname);
      }
    },
    onClose() {
      this.model = false
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}
</style>
